export const All = { label: '(All)', value: -1 }
export const Blank = { label: '(Blank)', value: -2 }